import { MASTER_DATA_ADD_PATH, MASTER_DATA_DETAIL_PATH, MASTER_DATA_PATH } from './constants.ts';
import MasterDataDetailPage from './pages/MasterDataDetailPage.tsx';
import MasterDataOverviewPage, { AddLookupDefinitionModal } from './pages/MasterDataOverviewPage.tsx';
import { canManageMasterData } from '../users/utils.ts';

export default [
    {
        path: MASTER_DATA_PATH,
        component: MasterDataOverviewPage,
        condition: ({ user }) => canManageMasterData(user),
        children: [
            {
                path: MASTER_DATA_ADD_PATH,
                condition: ({ user }) => canManageMasterData(user),
                component: AddLookupDefinitionModal,
            },
        ],
    },

    {
        path: MASTER_DATA_DETAIL_PATH,
        component: MasterDataDetailPage,
        condition: ({ user }) => canManageMasterData(user),
    },
];
